const separators = {
  american: {
    decimal: '.',
    thousand: ',',
  },
  european: {
    decimal: ',',
    thousand: '.',
  },
};
/**
 * Adds decimal and thousand separations to forwarded number
 * @param {Number} number
 * @param {Number} decimals - Number of decimal places
 * @param {Boolean} trim - Trim decimals for whole number, e.g. 12,00 or 12
 * @param {String} format - American or European number format
 */
export default function formatNumber(number, decimals = 2, trim = false, format = 'european') {
  if (Number.isNaN(parseFloat(number))) {
    return number || '-';
  }
  const origNum = parseFloat(number).toFixed(decimals);
  const x = origNum.split('.');
  let x1 = x[0];
  const x2 = x[1];
  const trimDecimals = trim && parseInt(x2, 10) === 0;
  const rgx = /(\d+)(\d{3})/;
  const separator = separators[format];

  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, `$1${separator.thousand}$2`);
  }

  if (decimals === 0 || trimDecimals) {
    return x1;
  }

  return x1 + separator.decimal + x2;
}
